(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let deferredInstallPrompt = null;

  /* =========================================================
     RRR FOOTER ACCORDION
     ========================================================= */

  function initializeFooter(footer) {
    if (!footer || footer.dataset.rrrFooterInitialized === 'true') return;

    footer.dataset.rrrFooterInitialized = 'true';

    const items = footer.querySelectorAll('[data-rrr-footer-item]');

    function updateLayout() {
      items.forEach((item) => {
        const button = item.querySelector('[data-rrr-footer-toggle]');
        const panel = item.querySelector('[data-rrr-footer-panel]');

        if (!button || !panel) return;

        if (!mobileQuery.matches) {
          button.setAttribute('aria-expanded', 'true');
          button.setAttribute('tabindex', '-1');

          panel.hidden = false;
          item.classList.add('is-open');
          return;
        }

        button.setAttribute('tabindex', '0');

        const isOpen = item.dataset.mobileOpen === 'true';

        button.setAttribute('aria-expanded', String(isOpen));
        panel.hidden = !isOpen;
        item.classList.toggle('is-open', isOpen);
      });
    }

    items.forEach((item) => {
      const button = item.querySelector('[data-rrr-footer-toggle]');
      const panel = item.querySelector('[data-rrr-footer-panel]');

      if (!button || !panel) return;

      button.addEventListener('click', () => {
        if (!mobileQuery.matches) return;

        const isOpen = button.getAttribute('aria-expanded') === 'true';
        const nextState = !isOpen;

        item.dataset.mobileOpen = String(nextState);

        button.setAttribute('aria-expanded', String(nextState));
        panel.hidden = !nextState;

        item.classList.toggle('is-open', nextState);
      });
    });

    updateLayout();

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', updateLayout);
    } else {
      mobileQuery.addListener(updateLayout);
    }
  }

  /* =========================================================
     RRR PWA INSTALL SYSTEM
     ========================================================= */

  function injectInstallStyles() {
    if (document.getElementById('RRRAppInstallStyles')) return;

    const style = document.createElement('style');

    style.id = 'RRRAppInstallStyles';

    style.textContent = `
      .rrr-app-install-link {
        -webkit-appearance: none;
        appearance: none;
        display: inline-block;
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: transparent;
        color: inherit;
        font: inherit;
        text-align: left;
        cursor: pointer;
      }

      .rrr-app-install-item[hidden] {
        display: none !important;
      }

      .rrr-app-install-modal[hidden] {
        display: none !important;
      }

      .rrr-app-install-modal {
        position: fixed;
        inset: 0;
        z-index: 2147483000;

        display: flex;
        align-items: center;
        justify-content: center;

        padding: 20px;

        background: rgba(0, 0, 0, 0.72);

        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
      }

      .rrr-app-install-modal__card {
        position: relative;

        width: min(100%, 420px);

        padding: 30px 24px 24px;

        border: 1px solid #2b2b2b;
        border-radius: 16px;

        background: #0b0b0b;
        color: #ffffff;

        box-shadow:
          0 25px 70px rgba(0, 0, 0, 0.45);

        font-family: inherit;
      }

      .rrr-app-install-modal__brand {
        margin: 0 44px 8px 0;

        color: #b7b7b7;

        font-size: 11px;
        font-weight: 600;
        line-height: 1.4;

        letter-spacing: 0.14em;
        text-transform: uppercase;
      }

      .rrr-app-install-modal__title {
        margin: 0 44px 12px 0;

        color: #ffffff;

        font-size: 22px;
        font-weight: 600;
        line-height: 1.25;
      }

      .rrr-app-install-modal__text {
        margin: 0;

        color: #c7c7c7;

        font-size: 14px;
        line-height: 1.7;
      }

      .rrr-app-install-modal__steps {
        margin: 18px 0 0;

        padding-left: 22px;

        color: #f3f3f3;

        font-size: 14px;
        line-height: 1.85;
      }

      .rrr-app-install-modal__close {
        position: absolute;

        top: 14px;
        right: 14px;

        display: inline-flex;
        align-items: center;
        justify-content: center;

        width: 36px;
        height: 36px;

        padding: 0;

        border: 1px solid #303030;
        border-radius: 50%;

        background: #151515;
        color: #ffffff;

        font-size: 22px;
        line-height: 1;

        cursor: pointer;
      }

      .rrr-app-install-modal__close:hover {
        background: #222222;
      }

      .rrr-app-install-modal__close:focus-visible,
      .rrr-app-install-link:focus-visible {
        outline: 2px solid currentColor;
        outline-offset: 3px;
      }

      @media screen and (max-width: 749px) {
        .rrr-app-install-modal {
          align-items: flex-end;

          padding:
            16px
            16px
            max(16px, env(safe-area-inset-bottom));
        }

        .rrr-app-install-modal__card {
          width: 100%;

          border-radius: 18px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function isStandalone() {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true
    );
  }

  function isIOS() {
    return (
      /iPad|iPhone|iPod/i.test(navigator.userAgent) ||
      (
        navigator.platform === 'MacIntel' &&
        navigator.maxTouchPoints > 1
      )
    );
  }

  function getInstallItems() {
    return document.querySelectorAll('.rrr-app-install-item');
  }

  function updateInstallVisibility() {
    const installed = isStandalone();

    getInstallItems().forEach((item) => {
      item.hidden = installed;
    });
  }

  /* =========================================================
     INSTALL HELP MODAL
     ========================================================= */

  function closeInstallModal() {
    const modal = document.querySelector('.rrr-app-install-modal');

    if (!modal) return;

    modal.hidden = true;

    document.body.style.removeProperty('overflow');
  }

  function createInstallModal() {
    let modal = document.querySelector('.rrr-app-install-modal');

    if (modal) return modal;

    modal = document.createElement('div');

    modal.className = 'rrr-app-install-modal';

    modal.hidden = true;

    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute(
      'aria-labelledby',
      'RRRAppInstallTitle'
    );

    modal.innerHTML = `
      <div class="rrr-app-install-modal__card">

        <button
          type="button"
          class="rrr-app-install-modal__close"
          aria-label="Close"
          data-rrr-install-close
        >
          &times;
        </button>

        <p class="rrr-app-install-modal__brand">
          Rare Rich Right
        </p>

        <h2
          class="rrr-app-install-modal__title"
          id="RRRAppInstallTitle"
        ></h2>

        <div data-rrr-install-copy></div>

      </div>
    `;

    document.body.appendChild(modal);

    modal.addEventListener('click', (event) => {
      if (
        event.target === modal ||
        event.target.closest('[data-rrr-install-close]')
      ) {
        closeInstallModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        !modal.hidden
      ) {
        closeInstallModal();
      }
    });

    return modal;
  }

  function showInstallHelp(mode = 'browser') {
    injectInstallStyles();

    const modal = createInstallModal();

    const title =
      modal.querySelector('#RRRAppInstallTitle');

    const copy =
      modal.querySelector('[data-rrr-install-copy]');

    if (!title || !copy) return;

    if (mode === 'ios') {
      title.textContent =
        'Install RRR on your iPhone';

      copy.innerHTML = `
        <p class="rrr-app-install-modal__text">
          Apple requires the app installation to be
          confirmed from Safari.
        </p>

        <ol class="rrr-app-install-modal__steps">
          <li>
            Open Rare Rich Right in Safari.
          </li>

          <li>
            Tap the Share button.
          </li>

          <li>
            Choose “Add to Home Screen”.
          </li>

          <li>
            Tap “Add”.
          </li>
        </ol>
      `;
    } else {
      title.textContent =
        'Install Rare Rich Right';

      copy.innerHTML = `
        <p class="rrr-app-install-modal__text">
          Your browser has not exposed the
          one-tap install window yet.
          Open your browser menu and choose
          “Install app” or “Add to Home screen”.
        </p>
      `;
    }

    modal.hidden = false;

    document.body.style.overflow = 'hidden';

    modal
      .querySelector('[data-rrr-install-close]')
      ?.focus();
  }

  /* =========================================================
     INSTALL CLICK
     ========================================================= */

  async function handleInstallClick() {
    if (isStandalone()) {
      updateInstallVisibility();
      return;
    }

    /*
     * Chrome / Edge / Android
     */

    if (deferredInstallPrompt) {
      const promptEvent = deferredInstallPrompt;

      deferredInstallPrompt = null;

      try {
        await promptEvent.prompt();

        const choice =
          await promptEvent.userChoice;

        if (choice?.outcome === 'accepted') {
          updateInstallVisibility();
        }
      } catch (error) {
        console.warn(
          '[RRR PWA] Install prompt failed:',
          error
        );

        showInstallHelp(
          isIOS() ? 'ios' : 'browser'
        );
      }

      return;
    }

    /*
     * iPhone / browsers without
     * beforeinstallprompt support
     */

    showInstallHelp(
      isIOS() ? 'ios' : 'browser'
    );
  }

  function initializeInstallButtons(container = document) {
    injectInstallStyles();

    container
      .querySelectorAll('[data-rrr-app-install]')
      .forEach((button) => {
        if (
          button.dataset.rrrInstallInitialized ===
          'true'
        ) {
          return;
        }

        button.dataset.rrrInstallInitialized =
          'true';

        button.addEventListener(
          'click',
          handleInstallClick
        );
      });

    updateInstallVisibility();
  }

  /* =========================================================
     INITIALIZE EVERYTHING
     ========================================================= */

  function initializeAllFooters(
    container = document
  ) {
    container
      .querySelectorAll('[data-rrr-footer]')
      .forEach(initializeFooter);

    initializeInstallButtons(container);
  }

  /* =========================================================
     PWA EVENTS
     ========================================================= */

  window.addEventListener(
    'beforeinstallprompt',
    (event) => {
      /*
       * Prevent browser mini-infobar.
       * We trigger install only when
       * customer clicks Install Our App.
       */

      event.preventDefault();

      deferredInstallPrompt = event;

      updateInstallVisibility();

      console.log(
        '[RRR PWA] Install prompt ready.'
      );
    }
  );

  window.addEventListener(
    'appinstalled',
    () => {
      deferredInstallPrompt = null;

      closeInstallModal();

      updateInstallVisibility();

      console.log(
        '[RRR PWA] App installed successfully.'
      );
    }
  );

  /* =========================================================
     PAGE LOAD
     ========================================================= */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeAllFooters();
      }
    );
  } else {
    initializeAllFooters();
  }

  /* =========================================================
     SHOPIFY THEME EDITOR SUPPORT
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAllFooters(event.target);
    }
  );
})();